import { combineReducers } from "redux";
import experimentsReducer from "firefly/ducks/experiments";

export default combineReducers({
  experiments: experimentsReducer,
});
